// src/hooks/useDynamicResources.js
import { useState, useEffect, useCallback } from 'react';
import customizationsV2Service from '../../../services/api/v2-app-config-services'; // Adjust path as needed
import { toast } from 'react-toastify';

const useDynamicResources = (projectId, version, configId, horizontalTab, configSchema) => {
  const [resourceList, setResourceList] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
console.log("useDynamicResources called with:", { projectId, version, configId, horizontalTab, configSchema }); 
  const fetchResources = useCallback(async () => {
    if (!configSchema) return; // Don't fetch if schema isn't ready

    // Determine if we should fetch based on the horizontalTab
    const shouldFetchForTab = horizontalTab === 'category' || horizontalTab === 'home';
    // For initial load, we might always want to fetch if projectId and version/configId are present.
    // Adjust this condition if resources are only needed for specific tabs even on initial load.
    const canFetch = (projectId && version) || configId;

    if (!canFetch || !shouldFetchForTab) {
        // If not on a relevant tab after initial load, or no identifiers, clear existing resources or do nothing
        // setResourceList({}); // Optional: clear if navigating away from relevant tabs
        return;
    }

    setIsLoading(true);
    setError(null);
    try {
      let payload = {};
      if (configId) {
        payload = { config_id: configId };
      } else {
        payload = { projectId, version };
      }
      
      const response = await customizationsV2Service.getV2Resources(payload);
      if (response.status) {
        setResourceList(response.data || {});
      } else {
        setError(response.error || 'Failed to fetch resources');
        toast.error(response.error?.msg || 'Failed to fetch resources');
        setResourceList({});
      }
    } catch (err) {
      console.error("Error fetching dynamic resources:", err);
      setError(err.message || 'An error occurred while fetching resources.');
      toast.error(err.message || 'An error occurred while fetching resources.');
      setResourceList({});
    } finally {
      setIsLoading(false);
    }
  }, [projectId, version, configId, horizontalTab, configSchema]);

  useEffect(() => {
    fetchResources();
  }, [fetchResources]); // fetchResources is memoized and includes all its dependencies

  return { resourceList, isLoading, error, refetchResources: fetchResources };
};

export default useDynamicResources;
